import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-viber',
  templateUrl: './viber.component.html',
  styleUrls: ['./viber.component.scss'],
})
export class ViberComponent {
  menuOpen = false;

  reviews = [
    {
      text: 'viber_page.testimonials_1_text',
      author: 'viber_page.testimonials_1_author',
    },
    {
      text: 'viber_page.testimonials_2_text',
      author: 'viber_page.testimonials_2_author',
    },
  ];

  protected faqList = [
    {
      question:'viber_page.faq_1_question',
      answer: 'viber_page.faq_1_answer'
    },
    {
      question:'viber_page.faq_2_question',
      answer: 'viber_page.faq_2_answer'
    },
    {
      question:'viber_page.faq_3_question',
      answer: 'viber_page.faq_3_answer'
    },
    {
      question:'viber_page.faq_4_question',
      answer: 'viber_page.faq_4_answer'
    },
    {
      question:'viber_page.faq_5_question',
      answer: 'viber_page.faq_5_answer'
    },

  ]

  protected viberRules = [
    {
      rule: 'viber.rule_1'
    },
    {
      rule: 'viber.rule_2'
    },
    {
      rule: 'viber.rule_3'
    },
    {
      rule: 'viber.rule_4'
    },
    {
      rule: 'viber.rule_5'
    },
  ]

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    if (this.menuOpen) {
      this.toggleMenu();
    }
  }

  protected readonly environment = environment;
}
